import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Condolence\DeleteCondoleanceController::__invoke
* @see app/Http/Controllers/Condolence/DeleteCondoleanceController.php
* @route '/api/condolence/{condolence}'
*/
const DeleteCondoleanceController = (args: { condolence: string | number | { id: string | number } } | [condolence: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: DeleteCondoleanceController.url(args, options),
    method: 'delete',
})

DeleteCondoleanceController.definition = {
    methods: ["delete"],
    url: '/api/condolence/{condolence}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Condolence\DeleteCondoleanceController::__invoke
* @see app/Http/Controllers/Condolence/DeleteCondoleanceController.php
* @route '/api/condolence/{condolence}'
*/
DeleteCondoleanceController.url = (args: { condolence: string | number | { id: string | number } } | [condolence: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { condolence: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { condolence: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            condolence: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        condolence: typeof args.condolence === 'object'
        ? args.condolence.id
        : args.condolence,
    }

    return DeleteCondoleanceController.definition.url
            .replace('{condolence}', parsedArgs.condolence.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Condolence\DeleteCondoleanceController::__invoke
* @see app/Http/Controllers/Condolence/DeleteCondoleanceController.php
* @route '/api/condolence/{condolence}'
*/
DeleteCondoleanceController.delete = (args: { condolence: string | number | { id: string | number } } | [condolence: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: DeleteCondoleanceController.url(args, options),
    method: 'delete',
})

export default DeleteCondoleanceController